export const communityGuesses = [
  { id: 1, user: "Maria T.", avatar: "MT", country: "🇺🇸", numbers: [7, 14, 23, 38, 52], game: "Powerball", date: "Apr 9, 2026", likes: 34, comment: "Feeling lucky this week! Hope we all win and donate for the babies!" },
  { id: 2, user: "James K.", avatar: "JK", country: "🇨🇦", numbers: [3, 11, 27, 44, 59], game: "Mega Millions", date: "Apr 9, 2026", likes: 21, comment: "Let's win together and help the little ones around the world 🍼" },
  { id: 3, user: "Lily W.", avatar: "LW", country: "🇬🇧", numbers: [5, 18, 29, 36, 50], game: "Powerball", date: "Apr 8, 2026", likes: 47, comment: "My lucky numbers from my grandma. If I win, every cent goes to the infants!" },
  { id: 4, user: "Carlos M.", avatar: "CM", country: "🇲🇽", numbers: [2, 16, 31, 42, 55], game: "Lucky Crown Pick", date: "Apr 8, 2026", likes: 18, comment: "Playing for the children. Let's make a difference together." },
  { id: 5, user: "Aisha B.", avatar: "AB", country: "🇳🇬", numbers: [9, 22, 33, 47, 58], game: "Mega Millions", date: "Apr 8, 2026", likes: 29, comment: "Every infant deserves love, milk and warmth. Win or not, I believe in this cause!" },
  { id: 6, user: "David L.", avatar: "DL", country: "🇦🇺", numbers: [1, 13, 25, 40, 53], game: "Powerball", date: "Apr 7, 2026", likes: 15, comment: "Sharing my numbers with the community. Together we can help so many babies." },
  { id: 7, user: "Yuki S.", avatar: "YS", country: "🇯🇵", numbers: [6, 19, 28, 37, 48], game: "Lucky Crown Pick", date: "Apr 7, 2026", likes: 38, comment: "I always pick numbers that mean something. These are for the infants who need us." },
  { id: 8, user: "Priya N.", avatar: "PN", country: "🇮🇳", numbers: [4, 17, 30, 43, 56], game: "Mega Millions", date: "Apr 7, 2026", likes: 22, comment: "Donated last time I won a small prize. This time going big for the babies!" },
  { id: 9, user: "Tom H.", avatar: "TH", country: "🇩🇪", numbers: [8, 20, 32, 45, 57], game: "Powerball", date: "Apr 6, 2026", likes: 11, comment: "Numbers chosen with love. Let's all hope and donate if we win!" },
  { id: 10, user: "Sofia R.", avatar: "SR", country: "🇧🇷", numbers: [10, 24, 35, 46, 60], game: "Lucky Crown Pick", date: "Apr 6, 2026", likes: 44, comment: "My heart goes out to every infant in need. This guess is for them." },
  { id: 11, user: "Kevin O.", avatar: "KO", country: "🇰🇷", numbers: [12, 21, 34, 49, 54], game: "Powerball", date: "Apr 6, 2026", likes: 27, comment: "Sharing my numbers publicly. If anyone wins with these, please donate!" },
  { id: 12, user: "Emma F.", avatar: "EF", country: "🇫🇷", numbers: [15, 26, 39, 51, 58], game: "Mega Millions", date: "Apr 5, 2026", likes: 33, comment: "Petite chance, grand coeur. Small chance, big heart — for the babies!" },
];

export const lotteryGuessGames = [
  {
    id: 1,
    name: "Powerball",
    jackpot: "$320,000,000",
    drawDate: "Apr 12, 2026",
    hotNumbers: [7, 14, 23, 38, 52],
    bonus: 9,
    participants: 18420,
    topGuess: [4, 17, 22, 36, 49],
  },
  {
    id: 2,
    name: "Mega Millions",
    jackpot: "$185,000,000",
    drawDate: "Apr 11, 2026",
    hotNumbers: [3, 18, 27, 41, 55],
    bonus: 12,
    participants: 12870,
    topGuess: [8, 21, 30, 44, 58],
  },
  {
    id: 3,
    name: "Lucky Crown Pick",
    jackpot: "$50,000,000",
    drawDate: "Apr 10, 2026",
    hotNumbers: [6, 11, 29, 33, 47],
    bonus: 4,
    participants: 9340,
    topGuess: [2, 15, 28, 37, 50],
  },
];

export const companyAds = [
  {
    id: 1,
    company: "Golden Dragon Restaurant",
    category: "Restaurant",
    tagline: "Authentic Chinese Cuisine — Dim Sum, BBQ & Seafood",
    description: "Family-owned since 1998. Banquet halls available for 10–500 guests. Catering services for corporate events.",
    location: "Los Angeles, CA",
    phone: "+1 (213) 555-0101",
    website: "goldendragonla.com",
    badge: "Gold Member",
    image: "https://public.readdy.ai/ai/img_res/79351efa77d86e3cca59416952c84e9a.jpg",
    icon: "ri-restaurant-line",
    color: "amber",
  },
  {
    id: 2,
    company: "PrimeAccounts CPA Firm",
    category: "CPA & Accounting",
    tagline: "Tax Planning, Audit & Business Advisory Services",
    description: "Certified Public Accountants serving small businesses, corporations, and individuals. IRS representation included.",
    location: "New York, NY",
    phone: "+1 (212) 555-0202",
    website: "primeaccountscpa.com",
    badge: "Gold Member",
    image: "https://readdy.ai/api/search-image?query=professional%20CPA%20accounting%20firm%20office%20modern%20clean%20desk%20calculator%20financial%20documents%20business%20simple%20background&width=320&height=200&seq=ad2&orientation=landscape",
    icon: "ri-calculator-line",
    color: "green",
  },
  {
    id: 3,
    company: "Sakura Sushi & Grill",
    category: "Restaurant",
    tagline: "Premium Japanese Dining — Omakase & Teppanyaki",
    description: "Award-winning sushi bar with fresh daily imports from Japan. Private dining rooms for business lunches.",
    location: "San Francisco, CA",
    phone: "+1 (415) 555-0303",
    website: "sakurasushisf.com",
    badge: "Basic Member",
    image: "https://readdy.ai/api/search-image?query=Japanese%20sushi%20restaurant%20elegant%20interior%20omakase%20teppanyaki%20premium%20dining%20beautiful%20presentation%20simple%20background&width=320&height=200&seq=ad3&orientation=landscape",
    icon: "ri-restaurant-2-line",
    color: "red",
  },
  {
    id: 4,
    company: "TaxPro Solutions LLC",
    category: "CPA & Tax",
    tagline: "Business Tax Returns, Bookkeeping & Payroll",
    description: "Over 20 years of experience. Specializing in import/export businesses, e-commerce, and international tax.",
    location: "Houston, TX",
    phone: "+1 (713) 555-0404",
    website: "taxprosolutions.com",
    badge: "Gold Member",
    image: "https://readdy.ai/api/search-image?query=tax%20accounting%20professional%20office%20clean%20modern%20financial%20planning%20business%20advisory%20team%20simple%20background&width=320&height=200&seq=ad4&orientation=landscape",
    icon: "ri-file-text-line",
    color: "teal",
  },
  {
    id: 5,
    company: "Bella Italia Ristorante",
    category: "Restaurant",
    tagline: "Authentic Italian — Pasta, Pizza & Fine Wine",
    description: "Imported ingredients from Italy. Wood-fired oven pizzas. Wine cellar with 200+ selections. Romantic ambiance.",
    location: "Miami, FL",
    phone: "+1 (305) 555-0505",
    website: "bellaitaliamiami.com",
    badge: "Basic Member",
    image: "https://readdy.ai/api/search-image?query=Italian%20restaurant%20elegant%20interior%20pasta%20pizza%20fine%20dining%20wine%20romantic%20ambiance%20warm%20lighting%20simple%20background&width=320&height=200&seq=ad5&orientation=landscape",
    icon: "ri-restaurant-line",
    color: "amber",
  },
  {
    id: 6,
    company: "GlobalTrade Freight Co.",
    category: "Logistics",
    tagline: "Sea, Air & Land Freight — Worldwide Shipping",
    description: "Full container load, LCL, customs clearance, and door-to-door delivery. Serving 150+ countries.",
    location: "Chicago, IL",
    phone: "+1 (312) 555-0606",
    website: "globaltradfreight.com",
    badge: "Gold Member",
    image: "https://readdy.ai/api/search-image?query=freight%20logistics%20shipping%20containers%20port%20cargo%20worldwide%20professional%20clean%20modern%20simple%20background&width=320&height=200&seq=ad6&orientation=landscape",
    icon: "ri-ship-line",
    color: "sky",
  },
  {
    id: 7,
    company: "SmartBooks Accounting",
    category: "CPA & Accounting",
    tagline: "Cloud Bookkeeping, CFO Services & Tax Strategy",
    description: "100% remote accounting firm. QuickBooks certified. Monthly financial reports and real-time dashboards.",
    location: "Seattle, WA",
    phone: "+1 (206) 555-0707",
    website: "smartbooksaccounting.com",
    badge: "Gold Member",
    image: "https://readdy.ai/api/search-image?query=cloud%20accounting%20bookkeeping%20modern%20office%20laptop%20financial%20dashboard%20professional%20clean%20simple%20background&width=320&height=200&seq=ad7&orientation=landscape",
    icon: "ri-bar-chart-line",
    color: "green",
  },
  {
    id: 8,
    company: "Spice Garden Indian Kitchen",
    category: "Restaurant",
    tagline: "Traditional Indian Flavors — Curry, Tandoor & Biryani",
    description: "Vegetarian and vegan options available. Catering for weddings and corporate events up to 1,000 guests.",
    location: "Dallas, TX",
    phone: "+1 (469) 555-0808",
    website: "spicegardenindian.com",
    badge: "Basic Member",
    image: "https://readdy.ai/api/search-image?query=Indian%20restaurant%20colorful%20curry%20tandoor%20biryani%20traditional%20spices%20elegant%20dining%20warm%20interior%20simple%20background&width=320&height=200&seq=ad8&orientation=landscape",
    icon: "ri-restaurant-2-line",
    color: "orange",
  },
  {
    id: 9,
    company: "Pacific Rim Law & CPA",
    category: "CPA & Legal",
    tagline: "Business Formation, Tax & Immigration Services",
    description: "Bilingual English/Chinese. Specializing in EB-5 visa, business immigration, and cross-border tax planning.",
    location: "San Jose, CA",
    phone: "+1 (408) 555-0909",
    website: "pacificrimlaw.com",
    badge: "Gold Member",
    image: "https://readdy.ai/api/search-image?query=law%20firm%20CPA%20professional%20office%20modern%20clean%20business%20formation%20immigration%20tax%20planning%20simple%20background&width=320&height=200&seq=ad9&orientation=landscape",
    icon: "ri-scales-line",
    color: "indigo",
  },
  {
    id: 10,
    company: "Le Petit Bistro",
    category: "Restaurant",
    tagline: "French Cuisine — Croissants, Crepes & Champagne Brunch",
    description: "Parisian-style café and bistro. Weekend brunch buffet. Private events and wine tasting evenings.",
    location: "Boston, MA",
    phone: "+1 (617) 555-1010",
    website: "lepetitbistroboston.com",
    badge: "Basic Member",
    image: "https://readdy.ai/api/search-image?query=French%20bistro%20cafe%20elegant%20Parisian%20interior%20croissants%20champagne%20brunch%20cozy%20warm%20lighting%20simple%20background&width=320&height=200&seq=ad10&orientation=landscape",
    icon: "ri-cup-line",
    color: "rose",
  },
  {
    id: 11,
    company: "Apex Business Consulting",
    category: "Business Services",
    tagline: "Market Entry, Strategy & Operations Consulting",
    description: "Helping companies expand into US, China, and Southeast Asia markets. 500+ successful projects.",
    location: "Atlanta, GA",
    phone: "+1 (404) 555-1111",
    website: "apexbizcon.com",
    badge: "Gold Member",
    image: "https://readdy.ai/api/search-image?query=business%20consulting%20strategy%20professional%20team%20meeting%20modern%20office%20clean%20corporate%20simple%20background&width=320&height=200&seq=ad11&orientation=landscape",
    icon: "ri-briefcase-line",
    color: "slate",
  },
  {
    id: 12,
    company: "Seoul BBQ House",
    category: "Restaurant",
    tagline: "Korean BBQ — Premium Wagyu, Pork Belly & Seafood",
    description: "All-you-can-eat options available. Private BBQ rooms for groups. Open until 2AM on weekends.",
    location: "Las Vegas, NV",
    phone: "+1 (702) 555-1212",
    website: "seoulbbqvegas.com",
    badge: "Basic Member",
    image: "https://readdy.ai/api/search-image?query=Korean%20BBQ%20restaurant%20premium%20wagyu%20pork%20belly%20seafood%20grill%20table%20elegant%20modern%20interior%20simple%20background&width=320&height=200&seq=ad12&orientation=landscape",
    icon: "ri-fire-line",
    color: "red",
  },
];
